import { NotFoundError, FetchError, UnauthorizedError, ForbiddenError } from '../../error';

export const checkError = (response: Response) => {
  if (!response.ok) {
    if (response.status === 401) {
      throw new UnauthorizedError();
    }

    if (response.status === 403) {
      throw new ForbiddenError();
    }

    if (response.status === 404) {
      throw new NotFoundError('Resource not found');
    }

    throw new FetchError('An error occurred', response.status);
  }
};
